module.exports = __webpack_public_path__ + "assets/img/icon-add.svg";